"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ParserOptions = void 0;
const lodash_escaperegexp_1 = __importDefault(require("lodash.escaperegexp"));
const lodash_isnil_1 = __importDefault(require("lodash.isnil"));
class ParserOptions {
  constructor(opts) {
    var _a;
    this.objectMode = true;
    this.delimiter = ',';
    this.ignoreEmpty = false;
    this.quote = '"';
    this.escape = null;
    this.escapeChar = this.quote;
    this.comment = null;
    this.supportsComments = false;
    this.ltrim = false;
    this.rtrim = false;
    this.trim = false;
    this.headers = null;
    this.renameHeaders = false;
    this.strictColumnHandling = false;
    this.discardUnmappedColumns = false;
    this.carriageReturn = '\r';
    this.encoding = 'utf8';
    this.limitRows = false;
    this.maxRows = 0;
    this.skipLines = 0;
    this.skipRows = 0;
    Object.assign(this, opts || {});
    if (this.delimiter.length > 1) {
      throw new Error('delimiter option must be one character long');
    }
    this.escapedDelimiter = lodash_escaperegexp_1.default(this.delimiter);
    this.escapeChar = (_a = this.escape) !== null && _a !== void 0 ? _a : this.quote;
    this.supportsComments = !lodash_isnil_1.default(this.comment);
    this.NEXT_TOKEN_REGEXP = new RegExp(`([^\\s]|\\r\\n|\\n|\\r|${this.escapedDelimiter})`);
    if (this.maxRows > 0) {
      this.limitRows = true;
    }
  }
}
exports.ParserOptions = ParserOptions;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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